<template>
  <div class="auth">
    <div class="editor-popup auth-pane">
      <h1 class="editor-popup__title">Reset password</h1>
      <form style="width: 100%;" v-on:submit.prevent="login">
        <div class="field">
          <label class="label" for="email">Email address</label>
          <input type="email" class="input input--outline" id="email" v-model="email" />
        </div>

        <div class="field">
          <button class="button button--fluid button--info" @click="reset">Reset</button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import api from "../../../api";

export default {
  name: "basic-page",
  data() {
    return {
      email: null,
      password: null
    };
  },
  methods: {
    reset: function() {
      api.auth
        .reset(this.email)
        .then(result => {
          if (result.success) {
            console.log(result.success);
          }
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.auth {
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #003f54;
  height: 100%;

  h1 {
    margin-top: 0;
  }

  &-pane {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-content: center;
    position: relative;
    background-color: #fff;
    border-radius: 5px;
    width: auto;
    height: auto;
    padding: 40px 100px;
    min-width: 580px;
  }
}
</style>
